// extracted by mini-css-extract-plugin
export default {"prosConsList":"ProsConsList_prosConsList__4VF9H"};